import {Injectable, OnInit} from '@angular/core';
import {environment} from '../../environments/environment';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import {HttpService} from './http.service';
import {GetCustomerResponseDto} from '../models/GetCustomerResponseDto';
import {PostSiteRequestDto} from '../models/PostSiteRequestDto';
import {PostImportCustomerRequestDto} from '../models/PostImportCustomerRequestDto';
import {HttpResponse} from '@angular/common/http';


@Injectable()
export class CustomersService implements OnInit {

    constructor(private httpService: HttpService) {
    }

    ngOnInit(): void {}

    importCustomers(customersData: string, categoryId: number, triggerCategoryId: number): Observable<HttpResponse<Object>> {
        const url = environment.ENDPOINTS.IMPORT_CUSTOMER;
        return this.httpService.postJson<Object>(url, this.mapCustomers(customersData, categoryId, triggerCategoryId));
    }

    getByCrmId(crmId: number): Observable<HttpResponse<GetCustomerResponseDto>> {
        const customerCrmId = crmId.toString();
        const url = environment.ENDPOINTS.GET_CUSTOMER_BY_ID.replace('{:crmId}', customerCrmId);
        return this.httpService.getJson<GetCustomerResponseDto>(url);
    }

    private mapCustomers(customersData: string, categoryId: number, triggerCategoryId: number): Array<PostImportCustomerRequestDto> {
        const customerLines = customersData.trim().split(/\r|\n/);
        const customers = new Array<PostImportCustomerRequestDto>();
        const delimiter = customersData.indexOf(',') > -1 ? ',' : ';';
        for (let i = 0; i < customerLines.length; i++) {
            const customerLine = customerLines[i].split(delimiter);
            if (customerLine.length !== 3) {
                throw new SyntaxError('Customer data csv syntax error!');
            }
            const customer = new PostImportCustomerRequestDto();
            customer.name = customerLine[0].trim();
            customer.crmId = parseInt(customerLine[1].trim(), 10);
            customer.categoryId = categoryId;

            const site = new PostSiteRequestDto();
            site.crmId = customer.crmId;
            site.url = customerLine[2].trim();
            site.triggerCategoryId = triggerCategoryId;

            customer.site = site;
            customers.push(customer);
        }
        return customers;
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/services/customers.service.ts